import * as ko from 'knockout'
import ObservableRacePage from '@classic/Betting-v2/Model/Observables/ObservableRacePage'
import bettingStateTemplate from './bettingstate.tpl.html'
import raceDisplayStateTemplate from './race.display.state.tpl.html'
import { RaceDisplayStateManagerViewModel } from './RaceDisplayStateManagerViewModel'
import { BettingStateManagerViewModel } from './BettingStateManagerViewModel'

if (!ko.components.isRegistered('race-display-state')) {
  ko.components.register('race-display-state', {
    viewModel: {
      createViewModel: (params: {
        meetingId: string
        raceNumber: number
        meetingDate: Date
        raceStatus: string
      }) => {
        const viewModel = new RaceDisplayStateManagerViewModel(params)
        return viewModel
      },
    },
    template: raceDisplayStateTemplate,
  })
}

if (!ko.components.isRegistered('betting-state')) {
  ko.components.register('betting-state', {
    viewModel: {
      createViewModel: (params: { raceInformation: ObservableRacePage }) => {
        const viewModel = new BettingStateManagerViewModel(params)
        return viewModel
      },
    },
    template: bettingStateTemplate,
  })
}
